"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.OtherContentType = void 0;
var OtherContentType;
(function (OtherContentType) {
    OtherContentType["General"] = "generalRequest";
    OtherContentType["Committee"] = "committeeComposition";
})(OtherContentType || (exports.OtherContentType = OtherContentType = {}));
